// extracted by mini-css-extract-plugin
export default {"label":"InvoiceDetails_label__NKQ4O","itemTable":"InvoiceDetails_itemTable__8LlB2","control":"InvoiceDetails_control__0hRTg"};